import React from 'react';
import OurWork from '../../components/ourWork';

const OurWorkPage = () => {
  return (
    <>
      <OurWork />
    </>
  );
};

export default OurWorkPage;
